import { AppIndexedDb } from './db';

export class CommonDb extends AppIndexedDb {

    public tableName: string = '';

    constructor(
        db: IDBDatabase,
        tableName?: string,
    ) {
        super();
        this.tableName = tableName ?? this.tableName ?? '';
        this.setDatabase(db)
    }

    public initializeStore(_db: IDBDatabase): void {
    }

    public setDatabase(db: IDBDatabase): void {
        this.db = db;
    }

}
